import { ArticleBlock } from '../../../../models/article';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2, ElementRef, OnChanges } from '@angular/core';
import { Editor, Toolbar } from 'ngx-editor';

@Component({
  selector: 'app-article-link',
  templateUrl: './article-link.component.html',
  styleUrls: ['./article-link.component.scss']
})
export class ArticleLinkComponent implements OnInit, OnChanges, OnDestroy {

  @Output() blockElementChange = new EventEmitter<ArticleBlock>();

  @Input() blockElement: ArticleBlock;

  editor: Editor;
  toolbar: Toolbar = [
    ['link']
  ];

  constructor(private renderer: Renderer2, private el: ElementRef) { }

  ngOnInit(): void {
    this.editor = new Editor();
  }

  ngOnChanges(): void {
    setTimeout(() => {
      if (this.blockElement?.isActiveForEdit) {
        const editorElement = this.el.nativeElement.querySelector('.ProseMirror.NgxEditor__Content');
        this.renderer.setAttribute(editorElement, 'autofocus', 'true');
        editorElement.focus();
      }
    }, 700);
  }
  onChange(e: string) {
    this.blockElement.data = e;
    this.blockElementChange.emit(this.blockElement);
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }
}
